import { connect } from 'react-redux'
import Map from '../components/Map'
import { updateViewport } from '../redux/modules/map'
import {
  getViewport,
  getBounds,
  mapStyleSelector,
  activeSelector,
  getMapTransition,
} from '../redux/selector'

const mapStateToProps = state => {
  return {
    viewport: getViewport(state),
    bounds: getBounds(state),
    style: mapStyleSelector(state),
    introMode: !activeSelector(state),
    transition: getMapTransition(state),
  }
}

const mapDispatchToProps = dispatch => ({
  onViewportChange: viewport =>
    dispatch(updateViewport({ viewport, transition: false })),
})

const MapContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Map)

export default MapContainer
